import { render } from "./TextTranslate.vue?vue&type=template&id=2db82be4&scoped=true"
import script from "./TextTranslate.vue?vue&type=script&lang=js"
export * from "./TextTranslate.vue?vue&type=script&lang=js"

import "./TextTranslate.vue?vue&type=style&index=0&id=2db82be4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db82be4"]])

export default __exports__